export const iconFontAwesomeArrowsCaretUp = (
	<i className="fa-solid fa-caret-up"></i>
);
